const pre = '/staff-identity/';
export default {
  path: '/staff-identity',
  title: '员工识别信息',
  header: 'home',
  icon: 'ios-settings',
  img: 'https://qiniu.hp.gimyingao.com/wecom/%E9%85%8D%E7%BD%AE2.png',
  imgS: 'https://qiniu.hp.gimyingao.com/wecom/%E9%85%8D%E7%BD%AE.png',
  children: [{
    path: `${pre}staff-list`,
    title: '员工识别信息'
  }, {
    path: `${pre}tag-config`,
    title: '员工标签设置'
  }, {
    path: `${pre}tag-task`,
    title: '标签同步任务',
    hide: true
  }, {
    path: `${pre}import`,
    title: '批量上传',
    hide: true
  }, {
    path: `${pre}import-record`,
    title: '导入记录',
    hide: true
  }]
};